import React, { Component } from 'react'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import Button from '@ui/Button'
import ButtonsRow from '@ui/ButtonsRow'
import Legends from '@ui/Legends'
import './styles.scss'

@observer
export default class Rating extends Component {
  renderLegends = () => <Legends list={this.props.legends} />

  render() {
    const {
      buttons,
      onSelect,
      selected,
      inactive,
      mode,
      textDirection,
      onChange,
      splitted,
      dontKnowButton,
      legends
    } = this.props
    const finalButtons = [...buttons]

    if (dontKnowButton && !dontKnowButton.inverted) {
      finalButtons.push(splitted ? [dontKnowButton] : dontKnowButton)
    }

    return (
      <div className='flex vertical rating-component' dir={textDirection}>
        <ButtonsRow
          buttons={finalButtons}
          onSelect={onSelect}
          selected={selected}
          inactive={inactive}
          mode={mode}
          onChange={onChange}
          splitted={splitted}
          fitContent
        />
        {legends && this.renderLegends()}
        {dontKnowButton && dontKnowButton.inverted && (
          <Button
            id={dontKnowButton.value}
            onClick={onSelect}
            primary={dontKnowButton.value === selected}
            content={dontKnowButton.text}
            value={dontKnowButton.value}
            inactive={inactive}
            className={classNames('dont-know-button', {
              inverted: dontKnowButton.inverted
            })}
          />
        )}
      </div>
    )
  }
}
